'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Swipeout = require('./Swipeout.web');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swipeout)["default"];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-swipeout/lib/index.web.js
 ** module id = 381
 ** module chunks = 0
 **/